module.exports = __webpack_public_path__ + "static/media/postman.d69dccd9.svg";